import axios from "axios";
import { localStorageItem } from '../../utils/LocalStorage';
import { KEY_LOCALSTORAGE } from "../../auth/core/_consts";
import { OctResponse } from '../../models/OctResponse';
import { urlParamsConfig } from "../../utils/ParamsUtils";

const API = localStorageItem.get(KEY_LOCALSTORAGE.CONFIGURATION)?.["apiUrl"] || process.env.REACT_APP_WMS_API_URL;
const API_DON_VI = API + "/organizations";
const API_DICH_VU = API + "/c-service";
const API_LOG = API + "/public/v1/api/patient-request";

export const searchDanhSachDV = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_DON_VI}` + `/search`;
  return axios.get(urlParamsConfig(url, searchData))
};

export const searchDanhSachDichVu = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_DICH_VU}` + `/search`;
  return axios.post(url, searchData);
};

export const searchLog = (searchData: any): Promise<OctResponse<any>>  => {
  const url = `${API_LOG}` + `/search`;
  return axios.post(url, searchData);
};

export const detailLog = (id: string) => {
  const url = `${API_LOG}` + `/${id}`;
  return axios.get(url);
};